var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00039 9.33366C6.88081 9.33366 6.76648 9.28466 6.68423 9.19833L3.62173 5.98999C3.35631 5.71233 3.55348 5.25033 3.9379 5.25033H5.54206V1.89616C5.54206 1.49424 5.86931 1.16699 6.27123 1.16699H7.72956C8.13148 1.16699 8.45873 1.49424 8.45873 1.89616V5.25033H10.0629C10.4473 5.25033 10.6445 5.71233 10.3791 5.98999L7.31656 9.19833C7.23431 9.28466 7.11998 9.33366 7.00039 9.33366Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9792 12.8333H1.02083C0.457917 12.8333 0 12.3754 0 11.8125V11.5208C0 10.9579 0.457917 10.5 1.02083 10.5H12.9792C13.5421 10.5 14 10.9579 14 11.5208V11.8125C14 12.3754 13.5421 12.8333 12.9792 12.8333Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.27bd9fb4.svg";
export { ForwardRef as ReactComponent };